import { render, staticRenderFns } from "./BlocTextUpdate.vue?vue&type=template&id=60440fec"
import script from "./BlocTextUpdate.vue?vue&type=script&lang=ts"
export * from "./BlocTextUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports